/**
 * @generated SignedSource<<d0e7cabb029dc188f565a2ef7d5ba407>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type tableBody_nativeIssueTable_project$data = {
  readonly key: string;
  readonly " $fragmentSpreads": FragmentRefs<"rows_jiraProject">;
  readonly " $fragmentType": "tableBody_nativeIssueTable_project";
};
export type tableBody_nativeIssueTable_project$key = {
  readonly " $data"?: tableBody_nativeIssueTable_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"tableBody_nativeIssueTable_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "tableBody_nativeIssueTable_project",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "rows_jiraProject"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "fb299128368e78f006e259d5eba3e81f";

export default node;
